// extracted by mini-css-extract-plugin
export default {"content":"Content_content__3ZaEO","toc":"Content_toc__nbk54","contentBody":"Content_contentBody__-VYN5","link":"Content_link__teOVX","breadcrumb":"Content_breadcrumb__baWTi"};